import { requestGet, requestGetFilterEmpty } from '@/common/request';
import { fetchDuccConfig } from '../../../../src/apis/ducc';

export default {
  // 保存规则设置
  async RuleSave(query, config) {
    return await requestGet('/rule/save', query, config);
  },
  // 活动管理组设置-是否活动成员
  async activityPlanIsMember(data) {
    return await requestGet('/activityPlan/isMember', data);
  },
  // 活动管理组设置-转移活动组长
  async activityPlanChangeOwner(data) {
    return await requestGet('/activityPlan/changeOwner', data);
  },
  // 活动管理组设置-查询活动成员
  async activityPlanGetMembers(data) {
    return await requestGet('/activityPlan/getMembers', data);
  },
  // 活动管理组设置-校验成员有效性（批量校验）
  async activityPlanCheckMembers(data) {
    return await requestGet('/activityPlan/checkMembers', data);
  },
  // 活动管理组设置-新增活动成员
  async activityPlanAddMembers(data) {
    return await requestGet('/activityPlan/addMembers', data);
  },
  // 活动管理组设置-删除活动成员
  async activityPlanDelMember(data) {
    return await requestGet('/activityPlan/delMember', data);
  },
  // 活动管理组设置-删除活动成员
  async activityPlan_getShareInfo(data) {
    return await requestGet('/activityPlan/getShareInfo', data);
  },
  // 综促 正向卡片列表
  async zongcuRelationList(data) {
    return await requestGetFilterEmpty('/zongcu/relationList', data);
  },
  // 取消关联
  async actRoomRelieve(query) {
    return await requestGet('/actRoom/relieve', query);
  },
  // 活动模块-取消关联
  async activityPlanRelieve(query) {
    return await requestGet('/activityPlan/relieve', query);
  },
  // 活动权限分享-添加分享组成员
  async activityPlanShare(query) {
    return await requestGet('/activityPlan/share', query);
  },
  // 活动权限分享-查询分享组成员
  async activityPlanListShare(query) {
    return await requestGet('/activityPlan/listShare', query);
  },
  // 活动权限分享-删除分享组成员
  async actRoomDeleteShare(query) {
    return await requestGet('/activityPlan/deleteShare ', query);
  },
  // 创建综促活动的类型 权限按钮
  async zongcuCanBeCreated(query) {
    return await requestGet('/zongcu/canBeCreated', query);
  },
  // 创建综促之后自动关联
  async zongcuRelation(query) {
    return await requestGet('/zongcu/relation', query);
  },
  // 素材底池-获取素材-830
  async materialPoolGet(query) {
    return await requestGet('/materialPool/get', query);
  },
  // 获取综促权限数据 - 促销类型
  // https://cf.jd.com/pages/viewpage.action?pageId=896266487
  async commonServiceGetBeCreatedData(query) {
    return await requestGet('/zongcu/newCanBeCreated', query);
  },
};

// 获取综促权限数据 - 促销类型
// https://cf.jd.com/pages/viewpage.action?pageId=896266487
export async function commonServiceGetBeCreatedData(query) {
  return await requestGet('/zongcu/newCanBeCreated', query);
}
